<template>
  <div class="chat-wrapper" :class="{ __collapse: chatCollapsed }">
    <div class="__chat-list">
      <div class="__chat-individual" :class="{ 'chat-collapsed': chat.collapsed }" v-for="chat in chatItems"
        :key="chat.id">
        <chat-header :profile="chat" @toggle-collapse="toggleChatCollapse(chat)" @remove="removeChat(chat)" />

        <div class="__body" :id="'chat-parent-' + chat.id" v-show="!chat.collapsed">
          <chat-message v-for="(message, i) in chat.messages" :key="chat.id + '-message-' + i" :message="message"
            :sender-name="chat.first_name" :is-current-user="message.sender_id === user_profile?.id" />
          <div v-if="chat.is_typing" class="typing-message">Typing...</div>
        </div>

        <chat-input v-show="!chat.collapsed" @send="message => sendMessage(chat, message)"
          @file-selected="data => onFileSelected(data, chat)" @upload-progress="data => onUploadProgress(data, chat)"
          @upload-completed="data => onUploadCompleted(data, chat)" @remove-file="() => removeFile(chat)" />
      </div>
    </div>

    <chat-list :is-collapsed="chatCollapsed" :show-search="show_search" :chat-connections="chatConnections"
      :new-connections="newConnections" @toggle-collapse="chatCollapsed = !chatCollapsed"
      @new-conversation="newConversation" @search="searchNewConnections" @add-chat="addChat" />
  </div>
</template>

<script>
import { eventBus } from '../../main'
import ChatHeader from './components/ChatHeader.vue'
import ChatMessage from './components/ChatMessage.vue'
import ChatInput from './components/ChatInput.vue'
import ChatList from './components/ChatList.vue'

export default {
  name: 'floating_chat',
  components: {
    ChatHeader,
    ChatMessage,
    ChatInput,
    ChatList,
  },
  data() {
    return {
      chatCollapsed: false,
      chatItems: [],
      connections: [],
      newConnections: [],
      show_search: false,
      user_profile: null,
      owner_user_profile: null,
      conversation_loading: false,
      message_loading: false,
      progress_file_upload: 0,
      tyiping_timer: 0,
      is_typing: false,
      is_typing_message: false,
      is_messaging: false,
      is_message_searching: false,
      sound: require("@/assets/audio/sound.mp3"),
      audio: null
    }
  },
  computed: {
    chatConnections() {
      let vm = this;
      if (vm.connections && vm.connections.length > 0) {
        return vm.connections
          .map((item) => {
            if (item) {
              let message = '';
              if (item.latestMessage) {
                message = item.latestMessage.message;
              }

              let user = null;
              if (item.invitee_id !== vm.user_profile?.id) {
                user = item.invitee;
              } else {
                user = item.inviter;
              }

              if (user) {
                return {
                  id: user.id,
                  first_name: user.first_name,
                  last_name: user.last_name,
                  profile_picture: user.profile_picture,
                  message: message,
                  is_online: false,
                  channel: user.channel,
                  is_typing: false,
                  messages: []
                };
              }
            }
            return null;
          })
          .filter(item => item !== null);
      }
      return [];
    }
  },
  sockets: {
    connect() { },
    register(id) {
      let vm = this;
      vm.chatConnections.forEach((item) => {
        if (item.id == id) {
          eventBus.$set(item, "is_online", true);
        }
      });
      if (vm.chatItems.length > 0) {
        vm.chatItems.forEach((chat) => {
          if (chat.id == id) {
            eventBus.$set(chat, "is_online", true);
          }
        });
      }
    },
    message(payload) {
      let vm = this;
      if (payload.id === vm.user_profile?.id) {
        vm.handleSocketMessages(payload);
        vm.playSound();
        vm.$store.dispatch('GET_CHAT_CONNECTIONS')
      }
    },
    typing(payload) {
      let vm = this;
      vm.chatItems.forEach((chat) => {
        if (payload.me_id == vm.user_profile?.id) {
          if (payload.user_id == chat.id) {
            eventBus.$set(chat, "is_typing", true);
          }
        }
      });
    },
    not_typing(payload) {
      let vm = this;
      vm.chatItems.forEach((chat) => {
        if (payload.me_id == vm.user_profile?.id) {
          if (payload.user_id == chat.id) {
            eventBus.$set(chat, "is_typing", false);
          }
        }
      });
    },
    is_online(payload) {
      let vm = this;
      vm.chatConnections.forEach((item) => {
        if (item.id == payload.id) {
          eventBus.$set(item, "is_online", payload.isOnline);
        }
      });
      if (vm.chatItems.length > 0) {
        vm.chatItems.forEach((chat) => {
          if (chat.id == payload.id) {
            eventBus.$set(chat, "is_online", payload.isOnline);
          }
        });
      }
    },
    leaving(id) {
      let vm = this;
      vm.chatConnections.forEach((item) => {
        if (item.id == id) {
          eventBus.$set(item, "is_online", false);
        }
      });
      if (vm.chatItems.length > 0) {
        vm.chatItems.forEach((chat) => {
          if (chat.id == id) {
            eventBus.$set(chat, "is_online", false);
          }
        });
      }
    }
  },
  methods: {
    playSound() {
      this.audio.play();
    },
    removeChat(chat) {
      const index = this.chatItems.findIndex(item => item.id === chat.id)
      if (index > -1) {
        this.chatItems.splice(index, 1)
      }
    },
    addChat(chat) {
      let vm = this
      vm.show_search = false
      const existingChat = this.chatItems.find(item => item.id === chat.id)
      if (!existingChat) {
        vm.message_loading = true;
        vm.$store
          .dispatch("MESSAGE_GET_CHAT", {
            receiver_id: chat.id
          })
          .then((response) => {
            vm.message_loading = false;
            eventBus.$set(chat, "messages", response.data);
            eventBus.$set(chat, "collapsed", false);
            eventBus.$set(chat, "is_typing", false);

            chat.messages.map((item, index) => {
              if (index > 0) {
                if (item.sender_id === chat.messages[index - 1].sender_id) {
                  eventBus.$set(item, "show_profile", false);
                } else {
                  eventBus.$set(item, "show_profile", true);
                }
              } else {
                eventBus.$set(item, "show_profile", true);
              }
              return item;
            });

            if (vm.chatItems.length > 2) {
              vm.chatItems.shift()
            }

            vm.chatItems.push(chat)
            vm.$socket.emit("is_online", { id: chat.id });

            this.$nextTick(() => {
              const el = document.getElementById('chat-parent-' + chat.id)
              if (el) el.scrollTop = el.scrollHeight
            })
          })
          .catch((error) => {
            vm.message_loading = false;
            console.log(error);
          });
        this.newConnections = []
      }
    },
    sendMessage(chat, message) {
      let vm = this;
      const payload = {
        is_file_message: message.isFileMessage,
        file_type: message.fileType,
        new_file_name: chat.new_file_name,
        file_name: message.fileName,
        file: chat.file,
        image: chat.image,
        video: chat.video,
        text: message.text,
        receiver_id: chat.id,
        channel: chat.channel
      };

      if (message.text) {
        vm.$socket.emit("typing", {
          user_id: vm.user_profile.id,
          me_id: chat.id,
        });
      }

      vm.$store
        .dispatch("MESSAGE_SEND_SMS", payload)
        .then((response) => {
          chat.messages.push(response.data);
          vm.notify(chat.id, response.data, vm.owner_user_profile, chat.channel);
          vm.$store.dispatch('GET_CHAT_CONNECTIONS');

          clearTimeout(vm.tyiping_timer);
          vm.tyiping_timer = setTimeout(() => {
            vm.$socket.emit("not_typing", {
              user_id: vm.user_profile.id,
              me_id: chat.id,
            });
          }, 1000);

          this.$nextTick(() => {
            const el = document.getElementById('chat-parent-' + chat.id)
            if (el) el.scrollTop = el.scrollHeight
          })
        })
        .catch((error) => {
          console.log(error);
        });
    },
    notify(userId, chat, sender, channel) {
      let data = {
        id: userId,
        data: chat,
        sender: sender,
        channel: channel
      };
      this.$socket.emit("message", data);
    },
    handleSocketMessages(obj) {
      this.chatItems.forEach(chat => {
        if (chat.id === obj.sender.id) {
          chat.messages.push(obj.data);
          this.$nextTick(() => {
            const el = document.getElementById('chat-parent-' + chat.id)
            if (el) el.scrollTop = el.scrollHeight
          })
        }
      })
    },
    onFileSelected(data, chat) {
      eventBus.$set(chat, "is_file_message", true);
      eventBus.$set(chat, "file_type", data.file_type);
      eventBus.$set(chat, "file", data.file);
      eventBus.$set(chat, "image", data.image);
      eventBus.$set(chat, "video", data.video);
      eventBus.$set(chat, "file_name", data.file_name);
    },
    onUploadProgress(data, chat) {
      eventBus.$set(chat, "progress_file_upload", parseInt(data[0].progress));
    },
    onUploadCompleted(data, chat) {
      eventBus.$set(chat, "new_file_name", data[0].response.name);
      this.sendFileMessage(chat);
    },
    removeFile(chat) {
      eventBus.$set(chat, "is_file_message", false);
      eventBus.$set(chat, "file_type", "");
      eventBus.$set(chat, "file", null);
      eventBus.$set(chat, "image", null);
      eventBus.$set(chat, "video", null);
      eventBus.$set(chat, "file_name", "");
      eventBus.$set(chat, "new_file_name", "");
      eventBus.$set(chat, "progress_file_upload", 0);
    },
    sendFileMessage(chat) {
      let vm = this;
      const payload = {
        is_file_message: true,
        file_type: chat.file_type,
        new_file_name: chat.new_file_name,
        file_name: chat.file_name,
        file: chat.file,
        image: chat.image,
        video: chat.video,
        text: "",
        receiver_id: chat.id,
        channel: chat.channel
      };

      vm.$store
        .dispatch("MESSAGE_SEND_SMS", payload)
        .then((response) => {
          chat.messages.push(response.data);
          vm.notify(chat.id, response.data, vm.owner_user_profile, chat.channel);
          vm.removeFile(chat);
          vm.$store.dispatch('GET_CHAT_CONNECTIONS');

          this.$nextTick(() => {
            const el = document.getElementById('chat-parent-' + chat.id)
            if (el) el.scrollTop = el.scrollHeight
          })
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getUserData() {
      let vm = this;
      vm.$store
        .dispatch("GET_ME_PROFILE_DATA")
        .then((response) => {
          let data = response.data;
          vm.owner_user_profile = data.user;
          vm.user_profile = {
            id: data.user.id,
            profile: data.user.profile_picture,
            names: data.user.first_name + " " + data.user.last_name,
            email: data.user.email,
            phone: data.profile.phone,
            job: data.employment.length > 0 ? data.employment[0].company.name : "",
            description: data.profile.description,
          };
          vm.getUserConversation("new");
        })
        .catch((error) => { });
    },
    getUserConversation(type = "chat") {
      let vm = this;
      if (type == "new") {
        vm.conversation_loading = true;
      }
      vm.$store
        .dispatch("MESSAGE_CONVERSATION")
        .then((response) => {
          vm.conversation_loading = false;
          vm.connections = response.data;

          // Check online status for each connection
          vm.chatConnections.forEach((item, index) => {
            vm.$socket.emit("is_online", {
              index: index,
              id: item.id
            });
          });
        })
        .catch((error) => {
          vm.conversation_loading = false;
          console.log(error);
        });
    },
    searchNewConnections(query) {
      let vm = this;
      if (query) {
        vm.$store
          .dispatch("MESSAGE_SEARCH_CONTACT", {
            q: query
          })
          .then((response) => {
            vm.newConnections = response.data.map(user => ({
              id: user.id,
              first_name: user.first_name,
              last_name: user.last_name,
              profile_picture: user.profile_picture,
              is_online: false,
              channel: user.channel
            }));
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        vm.newConnections = [];
      }
    }
  },
  mounted() {
    let vm = this;
    vm.audio = new Audio(vm.sound);
    vm.getUserData();
  }
}
</script>

<style lang="scss" scoped>
.chat-wrapper {
  position: fixed;
  bottom: 0px;
  z-index: 9999999999999999;
  right: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;

  @media (min-width: 300px) and (max-width: 630px) {
    bottom: 52px !important;
    right: 0px !important;
  }

  .__chat-list {
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-end;

    .__chat-individual {
      margin-right: 10px;
      height: 400px;
      width: 300px;
      z-index: 999999999 !important;
      box-shadow: 0 9px 8px rgba(0, 0, 0, 0.16);
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      transition: 500ms ease-in-out;
      display: flex;
      flex-direction: column;

      &.chat-collapsed {
        height: 45px;
      }

      .__body {
        background: #ffffff;
        width: 100%;
        padding: 10px 10px;
        height: 100%;
        cursor: pointer;
        overflow-y: auto !important;

        &::-webkit-scrollbar {
          background-color: transparent;
          width: 12px;
        }

        &::-webkit-scrollbar-track {
          background-color: transparent;
        }

        &::-webkit-scrollbar-thumb {
          background-color: #babac0;
          border-radius: 16px;
          border: 4px solid #f2f2f2;
        }

        &::-webkit-scrollbar-button {
          display: none;
        }
      }
    }
  }
}
</style>